
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/replay",
      function () {
        return require("private-next-pages/replay/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/replay"])
      });
    }
  